<div
  class="offer-customer-number text-left"
  [ingsvAdmBackgroundLoader]="loader">
  <label class="mb-0" for="comments"><b>{{ label }}</b></label>
  @if (!editView) {
    @if (!dataToSet) {
      <div
        class="action-section"
        (click)="editTextView()">
        <span>{{ label }}</span>
      </div>
    }
    @if (dataToSet) {
      <div class="action-section" (click)="editTextView()">
        <span>{{dataToSet}}</span>
      </div>
    }
  }
  @if (editView) {
    <div class="offer-comments-edit">
      <input
        name="offer-customer-number"
        class="bg-white mb-1"
        fieldSize="small"
        [(ngModel)]="data"
        nbInput
        fullWidth
        placeholder="{{ label }}"
        rows="5"/>
      <button
        size="small"
        status="info"
        (click)="editData()"
        nbButton>
        {{ 'OFFER_INFO.SAVE' | translate }}
      </button>
      <a
        class="ml-1"
        size="small"
        status="info"
        (click)="cancel()"
        nbButton>
        {{ 'OFFER_INFO.CANCEL' | translate }}
      </a>
    </div>
  }
</div>
